import * as blockchainsApi from './blockchainsApi'

export async function getBlockchains(
  params: blockchainsApi.BlockchainCatalogsParams,
): Promise<{ blockchains: blockchainsApi.BlockchainCatalogsDTO[] }> {
  return await blockchainsApi.fetchBlockchains(params)
}
